import { Typography } from '@mui/material';
import styled from 'styled-components';
import { FlexCenter } from '../Flex';
import { fontSize, radius, space } from '../../style/utils';

export const TypeChip = styled(FlexCenter)`
  padding: ${space('xxs', 'smMinus')};
  border-radius: ${radius('capsule')};
  border: 1px solid ${({ theme }) => theme.palette.border.strong};
  width: fit-content;
`;

export const TypeChipLabel = styled(Typography)`
  font-size: ${fontSize('xxs')};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  line-height: normal;
`;
